import {GET_TOKEN, LOGIN, USER_CHECK_LOGIN, USER_CHECK_SESSION, USER_INSERT, USER_SELECT} from 'src/redux/actions/actionTypes';

import {putEncStorage} from 'src/common/common';
import {eSessionKeys} from 'src/common/const';

let loginData = [];

export const mainAuthReducer = (state = loginData, action) => {
  switch (action.type) {
    case LOGIN:
      /* Login success */
      loginData.splice(0, loginData.length);
      if (action.payload.data === undefined) {
        return state;
      } else if (action.payload.data.resultCode === 'S0000') {
        loginData.push(action.payload.data.res);
        sessionStorage.setItem(eSessionKeys.TOKEN, action.payload.data.res.tokenInfo.accessToken);
        return loginData;
      }
      return state;
    case GET_TOKEN:
      loginData.splice(0, loginData.length);
      if (action.payload.data === undefined) {
        return state;
      } else if (action.payload.data.resultCode === 'S0000') {
        loginData.push(action.payload.data.res);
        putEncStorage(eSessionKeys.TOKEN, action.payload.data.res.access_token);
        putEncStorage(eSessionKeys.IS_CP, 'N');
        putEncStorage(eSessionKeys.LOGIN_DATA, JSON.stringify(action.payload.data.res));
        return loginData;
      }
      return state;
    case USER_CHECK_SESSION:
      loginData.splice(0, loginData.length);
      if (action.payload.data === undefined) {
        return state;
      } else if (action.payload.data.resultCode === 'S0000') {
        loginData.push(action.payload.data.res);
        return loginData;
      }
      return state;
    case USER_CHECK_LOGIN:
      loginData.splice(0, loginData.length);
      loginData.push(action.payload.data.resultCode);
      return loginData;
    case USER_SELECT:
    case USER_INSERT:
      loginData.splice(0, loginData.length);
      if (action.payload.data === undefined) {
        return state;
      } else if (action.payload.data.resultCode === 'S0000') {
        loginData.push(action.payload.data.resultCode);
        putEncStorage(eSessionKeys.USER, JSON.stringify(action.payload.data.res));
        return loginData;
      } else if (action.payload.data.resultCode === 'E7003') {
        loginData.push(action.payload.data.resultCode);
        return loginData;
      }
      return state;
    default:
      return state;
  }
};
